import { createAsyncThunk } from '@reduxjs/toolkit';
import { easyFetch } from './endpoint';

/* eslint-disable  @typescript-eslint/no-explicit-any */
export const fetchActivityList = createAsyncThunk('activity/fetchActivityList', async () => {
    const { list } = await easyFetch<any>('api/activity/list', 'GET');

    return Promise.resolve({ list });
});

export const fetchActivityDetail = createAsyncThunk('activity/fetchActivityDetail', async (activityId:string) => {
    const { content } = await easyFetch<any>(`api/activity/${activityId}`, 'GET');

    return Promise.resolve({ content });
});
